import { IconTypesProps } from './iconTypes'

const SvgStatusClean = ({
    primaryColor = '#010101',
    secondaryColor = '#0A9E24',
    reverse,
    dataTestId,
}: IconTypesProps) => {
    if (reverse) {
        const tempPrimaryColor = primaryColor
        primaryColor = secondaryColor
        secondaryColor = tempPrimaryColor
    }
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-testid={dataTestId}
        >
            <circle cx="12" cy="12" r="12" fill={secondaryColor} />
            <path
                d="M9.81818 14.2314L7.13564 11.4127L6.95455 11.2224L6.77345 11.4127L5.8189 12.4157L5.65488 12.5881L5.8189 12.7604L9.63709 16.7724L9.81818 16.9626L9.99928 16.7724L18.1811 8.17533L18.3451 8.00299L18.1811 7.83064L17.2266 6.82765L17.0455 6.63736L16.8644 6.82765L9.81818 14.2314Z"
                fill={primaryColor}
                stroke={primaryColor}
                strokeWidth="0.5"
            />
        </svg>
    )
}

export default SvgStatusClean
